export default "__VITE_ASSET__H45wTJ2j__"